<template>
    <div id="login-change">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" class="dropdown-toggle" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true"
               aria-expanded="false" data-boundary="window">
                <i class="fa fa-user mr-1 d-sm-none" aria-hidden="true"></i>
                <span class="hidden-xs-down">
                    {{ $translate("Ceres::Template.loginHello", {"username": username }) }}
                </span>
            </a>
            <div class="account-menu dropdown-menu dropdown-menu-right small m-0 p-0">
                <div class="list-group" aria-labelledby="accountMenuList">
                    <a :href="$ceres.urls.myAccount" class="list-group-item small">
                        <i class="fa fa-user"></i>
                        {{ $translate("Ceres::Template.loginMyAccount") }}
                    </a>
                    <a href="#" class="list-group-item small" v-logout>
                        <i class="fa fa-sign-out"></i>
                        {{ $translate("Ceres::Template.loginLogout") }}
                    </a>
                </div>
            </div>
        </div>
        <div v-if="!isLoggedIn">
            <a :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();">
                <i class="fa fa-sign-in" aria-hidden="true"></i>
                <span class="d-block d-md-inline-block">
                    &nbsp;{{ $translate("Ceres::Template.login") }}
                </span>
            </a>
        </div>
    </div>
</template>

<script>
import ValidationService from "ceres/app/services/ValidationService";
import {mapGetters, mapActions} from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters([
            "username",
            "isLoggedIn"
        ])
    },

    data() {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields() {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal() {
            this.loadComponent("login-modal");

        },

        createRegisterModal() {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
